import { inject, Injectable } from '@angular/core';
import { ClienteModel, ClienteService } from '@app/data';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private readonly isAuthenticatedSubject = new BehaviorSubject<boolean>(false);
  isAuthenticated$ = this.isAuthenticatedSubject.asObservable();

  private readonly AUTH_TOKEN_KEY = 'auth_token';
  private readonly USER_DATA_KEY = 'user_data';
  private readonly clienteService = inject(ClienteService);

  constructor() {
    // Verificar se existe token salvo
    const token = localStorage.getItem(this.AUTH_TOKEN_KEY);
    if (token) {
      this.isAuthenticatedSubject.next(true);
    }
  }

  criarTokenLogin() {
    localStorage.setItem(this.AUTH_TOKEN_KEY, 'token_exemplo');
    this.isAuthenticatedSubject.next(true);
  }

  async login(credentials: { document: string; phoneForm: string }): Promise<boolean> {
    const cleanDocument = credentials.document.replace(/[^\d]/g, '');
    const cliente: ClienteModel = await this.clienteService.getClienteValidacao(cleanDocument, credentials.phoneForm);
    if (cliente) {
      const userData = {
        id: cliente.idCliente || 1, // Se não tiver ID, coloca 1 por segurança
        name: cliente.nome || 'Cliente',
        document: cleanDocument,
      };
      // Salvar token e dados do usuário
      localStorage.setItem(this.USER_DATA_KEY, JSON.stringify(userData));
      localStorage.setItem('idCliente', cliente.idCliente.toString());
      return true; // Login deu certo
    } else {
      return false;
    }
  }

  logout(): void {
    localStorage.removeItem(this.AUTH_TOKEN_KEY);
    localStorage.removeItem(this.USER_DATA_KEY);
    this.isAuthenticatedSubject.next(false);
  }

  getUserData(): any {
    const userData = localStorage.getItem(this.USER_DATA_KEY);
    return userData ? JSON.parse(userData) : null;
  }

  isAuthenticated(): boolean {
    return this.isAuthenticatedSubject.value;
  }
}
